// Per-environment settings (BB-2558). The build scripts set REACT_APP_ENV:
//   npm run build:dev  -> "development"  (dev server)
//   npm run build:prod -> "production"   (prod server)
// `npm start` leaves it unset and talks to the local Django on localhost:8000.
const IS_BUILD = process.env.NODE_ENV === "production";

export const APP_ENV = process.env.REACT_APP_ENV || (IS_BUILD ? "unknown" : "local");

// Cashfree JS SDK: only the prod build takes real payments.
export const CASHFREE_MODE = APP_ENV === "production" ? "production" : "sandbox";

// Chat WebSockets are served by the same host as the app (app.mybotbridge.com,
// app.fintalq.com, dev.chatbot.bizcollab360.com, ...), so never hard-code a domain.
export const WS_BASE_URL = IS_BUILD
  ? `${window.location.protocol === "https:" ? "wss" : "ws"}://${window.location.host}`
  : "ws://localhost:8000";

// Stamped by scripts/deploy.sh so anyone can tell which commit is live.
export const BUILD_COMMIT = process.env.REACT_APP_GIT_SHA || "unknown";
